<template>
  <div>
    <div class="page page__list" v-if="!isChange">
      <search-bar
        @search="onSearch"
        name="bo_mothercode,pr_detail,pr_orispeccode,bo_wcname,BOM.creatorName"
        placeholder="输入产品、工作中心、工作人员进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/production/bom/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.bo_mothername}}</p>
            <p class="list-item-muted">{{item.bo_mothercode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.bo_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.bo_status!='已审核'}"
            >{{item.bo_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}个</label>
      </div>
    </div>
    <div class="page page__list" v-if="isChange">
      <search-bar
        @search="onSearch"
        name="ed_mothercode"
        placeholder="输入母件编号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/production/bom_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ed_code}}</p>
            <p class="list-item-muted">{{item.ed_mothercode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ed_type}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.ec_status!='已审核'}"
            >{{item.ec_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}个</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isChange: false,
      listUrl: "/api/make/bom/list",
      params: {},
      filters: [
        {
          type: "date",
          name: "bom.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "bo_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "bo_statuscode='AUDITED'"
            },
            {
              value: 3,
              label: "待变更",
              condition: "ec_statuscode='SUBMITTED'"
            },
            {
              value: 4,
              label: "已变更",
              condition: "ec_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value > 2
      this.listUrl = isChange ? '/api/make/ecndetail/list' : '/api/make/bom/list'
      this.params = isChange ? { caller: 'Bom', mode: 'MAIN' } : {}
      this.filters[0].name = isChange ? 'ecndetail.createTime' : 'bom.createTime'
      this.isChange = isChange ? true : false
      filterBar.initConfig()
      next()
    },
  }
};
</script>